import { render, staticRenderFns } from "./PendingAcceptanceBlock.vue?vue&type=template&id=0bcb6dd1&"
import script from "./PendingAcceptanceBlock.vue?vue&type=script&lang=js&"
export * from "./PendingAcceptanceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports